// extracted by mini-css-extract-plugin
module.exports = {"all":"e_G2","accent":"e_H2"};